import React, { useEffect, useState } from "react";
import SideBar from "../Sidebar/SideBar";
import { Icon } from "@iconify/react/dist/iconify.js";
import HelpDeskApi from "../../Api/HelpDesk";
import BusinessType from "../../Api/BusinessType";

const HelpDeskMaster = () => {

    const [itemId, setItemId] = useState("");
    const [data, setData] = useState([]);

    const [inputs, setInputs] = useState({
        title: "",
        description: "",
        language: "",
        businessType: "",
        priority: "",
        videoLinkUrl: "",
        pageUrl: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputs((prev) => ({ ...prev, [name]: value }));
    };

    // ---------------- FETCH ----------------
    const fetchData = async () => {
        const res = await HelpDeskApi.GetAllHelpDesk();
        if (res?.IsSuccess) setData(res.Result);
    };

    useEffect(() => {
        fetchData();
    }, []);

    // ---------------- SAVE ----------------
    const handleSave = async () => {
        const res = await HelpDeskApi.CreateHelpDesk({
            ...inputs,
            priority: Number(inputs.priority),
            createdBy: 1
        });

        if (res?.IsSuccess) {
            fetchData();
            resetForm();
        }
    };

    // ---------------- UPDATE ----------------
    const handleUpdate = async () => {
        const res = await HelpDeskApi.UpdateHelpDesk(itemId, {
            ...inputs,
            priority: Number(inputs.priority),
            updatedBy: 1
        });

        if (res?.IsSuccess) {
            fetchData();
            resetForm();
            setItemId("");
        }
    };

    // ---------------- EDIT ----------------
    const handleEdit = (item) => {
        setItemId(item.id);
        setInputs({
            title: item.title,
            description: item.description,
            language: item.language,
            businessType: item.businessType,
            priority: item.priority,
            videoLinkUrl: item.videoLinkUrl,
            pageUrl: item.pageUrl
        });
    };

    // ---------------- DELETE ----------------
    const handleDelete = async (id) => {
        const res = await HelpDeskApi.DeleteHelpDesk(id);
        if (res?.IsSuccess) {
            fetchData();
        }
    };

    const resetForm = () => {
        setItemId(0);
        setInputs({
            title: "",
            description: "",
            language: "",
            businessType: "",
            priority: "",
            videoLinkUrl: "",
            pageUrl: ""
        });
    };

    const [businessType, setBusinessType] = useState()

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await BusinessType.GetAllBusinessType();
                setBusinessType(data?.Result);
            } catch (err) {
                console.log(err);
            }
        }
        fetchData();
    }, [])

    const getBusinessName = (id) => {
        return businessType?.find(x => x.id == id)?.businessName || "-";
    };

    return (
        <div className="Flex-general-client-sidebar">
            <div className="sidebar-gen-width">
                <SideBar />
            </div>

            <div className="Main-general-Client">

                {/* HEADER */}
                <div className="header-general">
                    <h2 className="general-card-title">Help Desk Master</h2>
                </div>

                {/* ================= FORM ================= */}
                <div className="control_radius">

                    {/* TITLE + LANGUAGE */}
                    <div className="company_control">

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input
                                        className="modify_im_input mode_category1"
                                        name="title"
                                        value={inputs.title}
                                        onChange={handleChange}
                                    />
                                    <label className="modify_p_text2">Title</label>
                                </div>
                            </div>
                        </div>

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input
                                        className="modify_im_input mode_category1"
                                        name="language"
                                        value={inputs.language}
                                        onChange={handleChange}
                                    />
                                    <label className="modify_p_text2">Language</label>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* BUSINESS + PRIORITY */}
                    <div className="company_control">

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <select
                                        className="modify_im_input mode_category1"
                                        name="businessType"
                                        value={inputs.businessType}
                                        onChange={handleChange}
                                    >
                                        <option disabled></option>
                                        {businessType && businessType?.map((item, idx) => (
                                            <option key={idx} value={item.id}>{item.businessName}</option>
                                        ))}
                                    </select>
                                    <label className="modify_p_text2">Business Type</label>
                                </div>
                            </div>
                        </div>

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input
                                        type="number"
                                        className="modify_im_input mode_category1"
                                        name="priority"
                                        value={inputs.priority}
                                        onChange={handleChange}
                                    />
                                    <label className="modify_p_text2">Priority</label>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* VIDEO + PAGE URL */}
                    <div className="company_control">

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input
                                        className="modify_im_input mode_category1"
                                        name="videoLinkUrl"
                                        value={inputs.videoLinkUrl}
                                        onChange={handleChange}
                                    />
                                    <label className="modify_p_text2">Video Link URL</label>
                                </div>
                            </div>
                        </div>

                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input
                                        className="modify_im_input mode_category1"
                                        name="pageUrl"
                                        value={inputs.pageUrl}
                                        onChange={handleChange}
                                    />
                                    <label className="modify_p_text2">Page URL</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="stock-im-dep1">
                        <div className="input-box-Imo1 input-height2">
                            <div className="input-box-mok1">
                                <textarea
                                    className="modify_im_input mode_category1"
                                    name="description"
                                    value={inputs.description}
                                    onChange={handleChange}
                                    style={{ minHeight: 80 }}
                                />
                                <label className="modify_p_text2">Description</label>
                            </div>
                        </div>
                    </div>

                    {/* BUTTONS */}
                    <div className="ButtonTabSave">
                        {!itemId ? (
                            <button className="save-button-main-save hovered" onClick={handleSave}>
                                Save
                            </button>
                        ) : (
                            <button className="update-button-main-save hovered" onClick={handleUpdate}>
                                Update
                            </button>
                        )}

                        <button className="update-button-main-save hovered" onClick={resetForm}>
                            Reset
                        </button>
                    </div>

                </div>

                {/* ================= TABLE ================= */}
                <div className="company_info-text-im depart_top">Help Desk List</div>

                <div className="control_radius">
                    <div className="table-account-manager">
                        <table className="table-master-acc">

                            <thead className="header-table-account">
                                <tr>
                                    <th className="table-header-manager ac-sno-wth">S.No</th>
                                    <th className="table-header-manager">Title</th>
                                    <th className="table-header-manager">Language</th>
                                    <th className="table-header-manager">Business Type</th>
                                    <th className="table-header-manager">Priority</th>
                                    <th className="table-header-manager">Video</th>
                                    <th className="table-header-manager">Page URL</th>
                                    <th className="table-header-manager">Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={item.id}>
                                        <td className="table-data-account ac-sno-wth">{index + 1}</td>
                                        <td className="table-data-account">{item.title}</td>
                                        <td className="table-data-account">{item.language}</td>
                                        <td className="table-data-account">{getBusinessName(item.businessType)}</td>
                                        <td className="table-data-account">{item.priority}</td>
                                        <td className="table-data-account">
                                            <a href={item.videoLinkUrl} target="_blank" rel="noreferrer">View</a>
                                        </td>
                                        <td className="table-data-account">{item.pageUrl}</td>
                                        <td className="table-data-account">
                                            <button className="edit-btn-acc" onClick={() => handleEdit(item)}>
                                                <Icon icon="lucide:edit" />
                                            </button>

                                            <button className="delete-btn-acc" onClick={() => handleDelete(item.id)}>
                                                <Icon icon="material-symbols:delete" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default HelpDeskMaster;